type RadioInputProps = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  disabled?: boolean;
  checked?: boolean;
  readOnly?: boolean;
};

export default function RadioInput({
  value,
  onChange,
  className,
  disabled,
  checked,
  readOnly,
}: RadioInputProps) {
  return (
    <input
      className={`form-radio text-primary w-5 h-5 focus:ring-1 focus-visible:ring-1 focus:ring-primary focus-visible:ring-primary ${
        className ? className : ''
      }`}
      value={value}
      onChange={onChange}
      disabled={Boolean(disabled)}
      checked={checked}
      type="radio"
      readOnly={readOnly}
    />
  );
}
